module.exports = __webpack_public_path__ + "static/media/background_left.55b724cc.png";